import { practicalStep } from "../runTour"
import type { TutorialPart } from "./types"

/**
 * Onboarding part 1: create a student. Ends on the real click into
 * StudentCreatePage — the part hands off there instead of continuing
 * hands-on steps on the next page (see design.md, gestion-onboarding-tutorial).
 */
export const createStudentPart: TutorialPart = {
  id: "create-student",
  title: "Crear un estudiante",
  requiredPolicies: ["academy:students:edit"],
  route: "/instructor/students",
  waitForSelector: '[data-tour="module-create"]',
  steps: [
    {
      popover: {
        title: "Parte 1: crear un estudiante",
        description:
          "Este es el listado de estudiantes. Crear uno nuevo solo pide nombres, apellidos y email — el resto del perfil se completa después, cuando quieras.",
      },
    },
    practicalStep({
      element: '[data-tour="module-create"]',
      popover: {
        title: "👉 Hazlo tú: crea un estudiante",
        description:
          'Haz clic en "+ Crear estudiante" para abrir el formulario real. Llena nombres, apellidos y email — el resto lo puedes dejar en blanco y guardar igual.',
        side: "bottom",
      },
    }),
  ],
}
